import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Cz = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M21 0H0V14H21V0Z", fill: "#D7141A" }),
    React.createElement("path", { d: "M21 0H0V7H21V0Z", fill: "#FAFAF9" }),
    React.createElement("path", { d: "M10.5 7L0 0V14L10.5 7Z", fill: "#11457E" })), 'Cz', { width: 21, height: 14, viewBox: '0 0 21 14' });
export default Cz;
